import React, { useState } from "react";
import {
  MagnifyingGlassIcon,
  ChevronDownIcon,
  PlusIcon,
  EyeIcon,
  PencilIcon,
  TrashIcon
} from "@heroicons/react/24/outline";
import AddNewCoupon from "./AddNew";
import { useTranslation } from "../../contexts/LanguageContext";

const coupons = [
  {
    id: 1,
    code: "MUB20",
    name: "Offer 20% Off",
    seller: "waseem008",
    date: "03/08/2023",
  },
  {
    id: 2,
    code: "MUB20",
    name: "Offer 20% Off",
    seller: "waseem008",
    date: "03/08/2023",
  },
  {
    id: 3,
    code: "MUB20",
    name: "Offer 20% Off",
    seller: "waseem008",
    date: "03/08/2023",
  },
  {
    id: 4,
    code: "MUB20",
    name: "Offer 20% Off",
    seller: "waseem008",
    date: "03/08/2023",
  },
];

export default function AllCoupons() {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { t } = useTranslation();

  return (
    <div>
      <div className="bg-white rounded-[10px] border border-dashboardStroke shadow-[0px_9px_15px_rgba(0,0,0,0.07)] overflow-hidden">
        {/* Dark Header */}
        <div className="bg-dashboardDark h-16 px-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <h2 className="text-white font-semibold text-lg">{t("coupon.title")}</h2>
            <span className="text-white font-semibold">({coupons.length})</span>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 px-3 py-1.5 border border-white rounded">
              <MagnifyingGlassIcon className="w-[18px] h-[18px] text-white" />
              <input
                type="text"
                placeholder={t("common.search")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="bg-transparent text-white placeholder-white/70 text-sm font-light outline-none w-28"
              />
            </div>

            <button className="flex items-center gap-2 px-3 py-1.5 border border-white rounded text-white text-sm font-light">
              <span>{t("common.sortBy")}</span>
              <ChevronDownIcon className="w-[18px] h-[18px] text-themeLightGray" />
            </button>

            <button
              onClick={() => setIsOpen(true)}
              className="flex items-center gap-2 px-4 py-1.5 bg-dashboardCoral rounded text-white text-sm font-medium"
            >
              <PlusIcon className="w-[18px] h-[18px]" />
              <span>{t("common.addNew")}</span>
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-dashboardStroke">
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("coupon.col.srNo")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("coupon.col.code")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("coupon.col.name")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("coupon.col.seller")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("coupon.col.date")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-medium text-dashboardText">{t("coupon.col.actions")}</th>
              </tr>
            </thead>
            <tbody>
              {coupons.map((coupon, index) => (
                <tr
                  key={coupon.id}
                  className={`border-b border-dashboardStroke hover:bg-gray-50 transition-colors ${
                    index === 0 ? "shadow-[inset_3px_0px_0px_#FF7C17]" : ""
                  }`}
                >
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {coupon.id}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {coupon.code}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-medium text-dashboardCoral">
                    {coupon.name}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {coupon.seller}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {coupon.date}
                  </td>
                  <td className="px-4 py-4">
                    <div className="flex items-center gap-0.5">
                      <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                        <EyeIcon className="w-6 h-6 text-dashboardDark" strokeWidth={1.3} />
                      </button>
                      <div className="w-px h-6 bg-dashboardStroke"></div>
                      <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                        <PencilIcon className="w-6 h-6 text-dashboardDark" strokeWidth={1.3} />
                      </button>
                      <div className="w-px h-6 bg-dashboardStroke"></div>
                      <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                        <TrashIcon className="w-6 h-6 text-dashboardCoral" strokeWidth={1.3} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <AddNewCoupon isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
}
